<template>
    <van-tabs v-model="active" @click="tabclick">
        <van-tab title="全部" name="100">
            <van-list>
                <OrderListItem v-for="item in data" :key="item.id" :item="item" />
            </van-list>
        </van-tab>
        <van-tab title="待付订金" name="0">
            <van-list>
                <OrderListItem v-for="item in data" :key="item.id" :item="item" />
            </van-list>
        </van-tab>
        <van-tab title="待收车"  name="1">
            <van-list>
                <OrderListItem v-for="item in data" :key="item.id" :item="item" />
            </van-list>
        </van-tab>
        <van-tab title="已完成"  name="2">
            <van-list>
                <OrderListItem v-for="item in data" :key="item.id" :item="item" />
            </van-list>
        </van-tab>
        <UsedCarFooter />
    </van-tabs>
</template>

<script>
import { 
    Tab, 
    Tabs,
    List,
} from 'vant'

import { UsedCarOrderApi } from '@/api/usedcar'
import OrderListItem from '@/view/usedcar/components/orderlistitem'
import UsedCarFooter from '@/view/usedcar/components/usedcarfooter'

export default {
    components: {
        [Tabs.name]: Tabs,
        [Tab.name]: Tab,
        [List.name]: List,
        OrderListItem,
        UsedCarFooter
    },
    data() {
        return {
            active: '100',
            data: [],
            loading: false,
            finished: false,
            total: 0,
            query: {
                title: null,
                state: '100',
                page: 1,
                page_size: 10
            }
        }
    },
    mounted() {
        this.getData()
    },
    methods: {
        getData() {
            var that = this
            that.loading = true
            that.data = []
            this.axios.get(UsedCarOrderApi, { params: this.query}).then((ret) => {
                console.log(ret)
                that.loading = false
                that.total = ret.count
                if (ret.results == null || ret.results.length ===0 ) {
                    that.finished = true
                    return
                }
                that.data = ret.results
                if (that.data.length >= that.total) {
                    that.finished = true
                }
            })
        },
        tabclick(sort) {
            this.active = sort
            this.query.state = sort
            this.getData()
        },
        onLoad() {
            this.query.page = this.query.page + 1
            this.getData()
        }
    }
}
</script>

